import CartCheckoutCtAsPage from "@faire/prototype-playground/workspace/vikas/cart-checkout-ctas";
import InstacartStyleIncentiveBannerPage from "@faire/prototype-playground/workspace/vikas/instacart-incentive-banner";
import OneBannerToRuleThemAllPage from "@faire/prototype-playground/workspace/vikas/one-banner-to-rule-them-all";
import { Route, Switch } from "react-router-dom";

export function VikasLalwaniRoutes() {
  return (
    <Switch>
      <Route
        path="/vikas/cart-checkout-ctas"
        component={CartCheckoutCtAsPage}
      />
      <Route
        path="/vikas/instacart-incentive-banner"
        component={InstacartStyleIncentiveBannerPage}
      />
      <Route
        path="/vikas/one-banner-to-rule-them-all"
        component={OneBannerToRuleThemAllPage}
      />
    </Switch>
  );
}

export const slug = "vikas";
